export enum SearchResponseOrder {
    mostPopular = 0,
    ascending = 1,
    descending = 2,
}
